import React, { use } from "react";
import { useLocation } from "react-router-dom";

import ZoomMeeting from "../components/ZoomMeeting";
import { useAuth } from "../context/AuthContext";
import { parseZoomLink } from "../utils/parseZoomLink";

export default function Meeting() {
  const { user } = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const link = searchParams.get("link") || "";
  const sessionID = searchParams.get("sessionID");
  const meetingID = searchParams.get("meetingID");
  const meetingType = searchParams.get("type");

  const { password } = parseZoomLink(link);

  return (
    <ZoomMeeting
      sessionID={sessionID}
      meetingNumber={meetingID}
      passWord={password}
      userName={
        user?.first_name +
          " " +
          user?.second_name +
          " " +
          user?.third_name +
          " " +
          user?.last_name +
          "-" +
          user?.national_id || user?.ministerial_id
      }
      userEmail={user?.email}
      meetingType={meetingType}
    />
  );
}
